<template>
  <div>
    <CruiseDetailRow v-if="cruiseDetail.isRow"/>
    <CruiseDetailHp v-else/>
  </div>
</template>

<script>
const CruiseDetailHp = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailHp.vue");
  const CruiseDetailRow = () =>
  import("@/components/Cruise/CruiseDetail/CruiseDetailRow.vue");
import { gioTracking} from '@/utilities/tools'

export default {
  name: "CruiseDetail",
  components: {
    CruiseDetailHp,
    CruiseDetailRow
  },

 
  activated() {
    const shipCode = this.$router.currentRoute.query.shipCode;
    const sailDate = this.$router.currentRoute.query.sailDate;
    if (shipCode != this.shipCode || sailDate != this.sailDate) {
      window.scrollTo(0, 0);
      this.initPage();
    }
  
  },

  computed:{
    // 航线详情
    cruiseDetail() {
      return this.$store.state.cruise.cruiseDetail.data;
    },
  }, 
 
  methods: {
    
    // 页面初始化
    async initPage() {
      console.log("CruiseDetail initPage11");
      const shipCode = this.$router.currentRoute.query.shipCode;
      const sailDate = this.$router.currentRoute.query.sailDate;
      const userToken = this.$store.state.user.userToken;
      if (this.shipCode != shipCode || this.sailDate != sailDate) {
        try {
          if (window && window.gio) {
            window.gio("app.set", "ShipCode", shipCode);
            window.gio("app.set", "SailDate", sailDate);
            window.gio("page.set", "CruiseLine", shipCode + sailDate);
            window.gio("page.set", "ShipCode", shipCode);
            window.gio("page.set", "SailDate", sailDate);
            window.gio("track", "BF01_DetailPages", { hmsr: "" });
            gioTracking("track", "CruiseDetail");
            gioTracking("track", "evt_cruiseDetail ", {
              shipCode: shipCode,
              sailDate: sailDate,
            });
          }
        } catch (e) {
          console.error(e);
        }
        this.$loading.show();
        await this.$store.dispatch("GET_CRUISE_DETAIL", {
          requestData: {
            shipCode: shipCode,
            sailDate: sailDate,
            username: userToken,
            tagSource: "online",
          },
        });
        this.$loading.hide();
      }
    },
  }
};
</script>

<style lang="less" scoped>

</style>
